
export type ComposerPayloadPollOptionsItem = {
  /** @maxLength 50 */
  text?: string;
};
